import styled from 'styled-components';
export const StyledGameWeek = styled.div`
  border: 1px solid ${(props) => props.selected ? props.theme.gameWeekSelected_border : props.theme.gameWeek_border} !important;
  color: ${(props) => props.selected ? props.theme.gameWeekSelected_border : props.theme.gamwWeek_text} !important;
`;

export const StyledGameWeekTimer = styled.div`  
  background-color: ${(props) => props.theme.gameWeek_timer_bg} !important;
`;

export const StyledGameWeekLive = styled.div`  
  background-color: ${(props) => props.theme.gameWeel_live_bg} !important;
 color: ${(props) => props.theme.gameWeel_live_text} !important;
`;